import { SceneObject } from '../systems/core/scene-object.js';


export const set_color = (entity, color) => {
  entity[SceneObject].material.color.set(color);
};
